module.exports = __webpack_public_path__ + "static/media/blue_platinum_labdiamond_sapphire_engagement_ring.d9f19ea5.jpg";